// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PreviewAnnouncement--next-sr-only--1t--los","title":"PreviewAnnouncement--title--Gv11Di_"};